import styled from 'styled-components';
export var PillBody = styled.div.withConfig({
  displayName: "partials__PillBody",
  componentId: "sc-1oh01h0-0"
})(["padding:18px 24px;"]);
export var TitleBlock = styled.div.withConfig({
  displayName: "partials__TitleBlock",
  componentId: "sc-1oh01h0-1"
})(["margin-top:24px;text-align:center;"]);
export var ComponentBlock = styled.div.withConfig({
  displayName: "partials__ComponentBlock",
  componentId: "sc-1oh01h0-2"
})(["max-width:240px;margin:0 auto;margin-top:24px;"]);